import React from 'react';
import PropTypes from 'prop-types';
import IconInfoBlue from '../../components/icons/IconInfoBlue';
import IconWarning from '../../components/icons/IconWarning';
import styles from './styles.scoped.css';

export default function BannerRuleSubsidi({
  type = 'info',
  text,
  children,
  icon,
  size = 24,
  className = '',
  style = {},
}) {
  const isWarning = type === 'warning';

  const defaultIcon = isWarning ? (
    <IconWarning color="#FC8338" />
  ) : (
    <IconInfoBlue size={size} />
  );

  const bannerStyleClass = isWarning ? styles.bannerRuleWarning : styles.bannerRuleInfo;
  const containerClass = `${styles.bannerRuleContainer} ${bannerStyleClass} ${className}`.trim();

  const defaultContent = isWarning ? (
    <>
      Saat ini tidak ada informasi besaran subsidi aktif (informasi aktif pada tanggal{' '}
      <strong>20 Agustus - 31 Agustus 2026</strong>).
    </>
  ) : (
    <>
      Per tanggal <strong>1 Agustus 2026</strong> informasi besaran subsidi aktif mengikuti
      aturan baru <strong>Rp14.000.</strong>
    </>
  );

  const content = children || text || defaultContent;

  return (
    <div className={containerClass} style={style}>
      <div
        className={styles.bannerRuleIconWrapper}
        style={{ width: size, minWidth: size, height: 'auto' }}
      >
        {icon || defaultIcon}
      </div>
      <div className={styles.bannerRuleText}>{content}</div>
    </div>
  );
}

BannerRuleSubsidi.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.node,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
  text: PropTypes.node,
  type: PropTypes.oneOf(['info', 'warning']),
};
